import { Flex } from 'component/base/Grid';
import styled from 'styled-components';

import { IAppLayout } from './types';

export const calcWidth = (width: string, extra = '0px') =>
  `calc(${width} - ${extra})`;

export const Container = styled(Flex)<IAppLayout>`
  background-color: ${(props) => props.theme.colors.white};
  transition: margin 0.1s ease-in-out;
`;

Container.defaultProps = {
  flexDirection: 'row',
  flexGrow: 1,
};

export const Main = styled(Flex)`
  width: 100%;
`;

Main.defaultProps = {
  flexDirection: 'column',
};

export const FixedHeaderContainer = styled(Flex)`
  background-color: ${(props) => props.theme.colors.white};
  z-index: 2;
  box-shadow: 1px 0 0 1px #e5e5e5;
  justify-content: flex-end;
  position: fixed;
  top: 0;
  right: 0;
  width: ${(props) =>
    `calc(100% - ${props.theme.layout.leftNav.width} - 1rem )`};
`;

export const Header = styled(Flex)`
  justify-content: flex-end;
  align-items: center;
  position: static;
  width: 100%;
`;

Header.defaultProps = {
  p: 2,
  pr: 35,
};
